module.exports = __webpack_public_path__ + "img/policy-bg.09457823.png";